import { useContext } from "react"
import { AuthContext } from "../Components/contexts/AuthProvider"

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;